module.exports = __webpack_public_path__ + "img/friend.aa442aa5.png";